var React = require('react');

function Redo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M47.47 0C48.314 0 49 .685 49 1.53v15.31a1.53 1.53 0 01-1.53 1.53H32.16a1.53 1.53 0 010-3.06h13.777V1.53A1.533 1.533 0 0147.47 0z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M44.7 17.35A21.43 21.43 0 0024.481 3.061c-11.836.007-21.428 9.609-21.42 21.444.007 11.836 9.609 21.426 21.444 21.418a1.53 1.53 0 11.002 3.062C10.982 48.995.008 38.035 0 24.508-.009 10.981 10.953.008 24.48 0a24.492 24.492 0 0123.106 16.329 1.53 1.53 0 11-2.887 1.02z","key":1})]);
}

Redo.defaultProps = {"viewBox":"0 0 49 49"};

module.exports = Redo;

Redo.default = Redo;
